import React from 'react';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { connect } from 'react-redux';
import { Field } from 'react-final-form';

import RenderEntityTable from 'forms/RenderEntityTable';
import { SchemaEntityTypeId } from 'services/schemas/types';
import { EntityId } from 'services/entities/types';
import { SPRAYED_ENTITIES_BY_DATE_LOAD_NAMESPACE } from 'services/sprayedEntitiesByDate/constants';
import {
    makeSelectInnerEntitiesGroupedByVariety,
    makeSelectInnerEntityIds
} from './selectors';
import { InnerEntityOptions } from '../SpraySchemaInnerEntityOptions/types';

interface ConnectedProps {
    innerEntityIds: EntityId[];
    innerEntitiesGroupedByVariety: Record<string, InnerEntityOptions>;
}

export interface OwnProps {
    name: string;
    validate?: any;
    entityId?: EntityId;
    entityTypeId: SchemaEntityTypeId;
    options: InnerEntityOptions;
}

export type Props = OwnProps & ConnectedProps;

export class SpraySchemaInnerEntityTableFieldRenderComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const {
            name,
            validate,
            entityTypeId,
            entityId,
            innerEntityIds,
            innerEntitiesGroupedByVariety
        } = this.props;

        return (
            <Field
                component={RenderEntityTable}
                subscription={{
                    value: true,
                    touched: true,
                    error: true,
                    submitFailed: true,
                    dirtySinceLastSubmit: true,
                    invalid: true
                }}
                name={name}
                validate={validate}
                entityTypeId={entityTypeId}
                entityId={entityId}
                innerEntityIds={innerEntityIds}
                innerEntitiesGroupedByVariety={innerEntitiesGroupedByVariety}
                namespace={SPRAYED_ENTITIES_BY_DATE_LOAD_NAMESPACE}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    innerEntityIds: makeSelectInnerEntityIds(),
    innerEntitiesGroupedByVariety: makeSelectInnerEntitiesGroupedByVariety()
});

export default connect(mapStateToProps)(
    SpraySchemaInnerEntityTableFieldRenderComponent
);
